(function () {
  const TABS_SELECTOR =
    'x-tabs.content-tabs:not(.predictive-search__tabs):not(.main-search__tabs)[data-url-hash]';

  function getTabButtons(tabsEl) {
    return Array.from(
      tabsEl.querySelectorAll('button[role="tab"][slot="title"][data-tab-hash]')
    );
  }

  function findTabIndex(buttons, hash) {
    if (!hash) return -1;

    const normalized = decodeURIComponent(hash).toLowerCase();

    return buttons.findIndex(
      (button) => button.dataset.tabHash.toLowerCase() === normalized
    );
  }

  function buildHashUrl(hash) {
    return `${window.location.pathname}${window.location.search}#${hash}`;
  }

  function activateTabFromHash(tabsEl, scrollIntoView) {
    const buttons = getTabButtons(tabsEl);
    const index = findTabIndex(buttons, window.location.hash.slice(1));

    if (index < 0) return;

    tabsEl.selectedIndex = index;

    if (scrollIntoView) {
      tabsEl.scrollIntoView({ block: 'start' });
    }
  }

  function initTabsHash(tabsEl) {
    if (tabsEl.dataset.hashInitialized === 'true') return;

    tabsEl.dataset.hashInitialized = 'true';

    tabsEl.addEventListener('click', (event) => {
      const button = event.target.closest('button[role="tab"][slot="title"]');

      if (!button || !tabsEl.contains(button) || !button.dataset.tabHash) return;

      history.replaceState(null, '', buildHashUrl(button.dataset.tabHash));
    });

    window.addEventListener('hashchange', () => {
      activateTabFromHash(tabsEl, true);
    });

    if (window.location.hash) {
      requestAnimationFrame(() => {
        activateTabFromHash(tabsEl, true);
      });
    }
  }

  function initAllTabsHash() {
    customElements.whenDefined('x-tabs').then(() => {
      document.querySelectorAll(TABS_SELECTOR).forEach(initTabsHash);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTabsHash);
  } else {
    initAllTabsHash();
  }

  document.addEventListener('shopify:section:load', initAllTabsHash);
})();
